var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('app-placeholder',{attrs:{"disclaimer":_vm.$t('app.common.disclaimer.msg.loading'),"loading":true,"footerStyle":false,"loaderSize":200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }